import {z} from 'zod';
import {AssetSetType} from './assetSetSchema';
// import {DownloadOptionType} from './downloadOptionSchema';

// export enum ProgressMessageObjectType {
//     ASSET = 'asset',
//     SYNC_CLIENT_DELTA = 'syncClientDelta',
//     ATTRIBUTE_DATA_IMPORT = 'attributeDataImport',
//     USER_DATA_IMPORT = 'userDataImport',
//     ATTRIBUTE_DATA_IMPORT_ROW = 'attributeDataImportRow',
//     USER_DATA_IMPORT_ROW = 'userDataImportRow',
//     METADATA_MAPPING = 'metadataMapping',
// }

// export enum ProgressMessageTaskType {
//     ALL = 'all',
//     METADATA = DownloadOptionType.METADATA,
//     SYNC_CLIENT_ANALYSIS = 'SyncClientAnalysis',
//     USER_IMPORT = 'UserImport',
// }

export const ProgressMessageSchema = z.object({
	code: z.number().int(),
	codeLabel: z.string(),
	objectId: z.number().int(),
	objectType: z.nativeEnum(AssetSetType),
	objectLabel: z.string(),
	taskId: z.number().int(),
	taskName: z.string(),
	taskType: z.string(), // z.nativeEnum(ProgressMessageTaskType),
});

export const DownloadWarningsSchema = z.object({
	messageCount: z.number().int().gt(-1, 'Invalid count'),
	progressMessages: z.array(ProgressMessageSchema),
});

export type IDownloadWarnings = z.infer<typeof DownloadWarningsSchema>;

export type IProgressMessage = z.infer<typeof ProgressMessageSchema>;
